/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ResourceLabelBar.vue?vue&type=template&id=6c938654&scoped=true&"
import script from "./ResourceLabelBar.vue?vue&type=script&lang=js&"
export * from "./ResourceLabelBar.vue?vue&type=script&lang=js&"
import style0 from "./ResourceLabelBar.vue?vue&type=style&index=0&id=6c938654&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c938654",
  null
  
)

export default component.exports